<template>
    <el-dialog
        title="添加设备"
        :visible.sync="dialogVisible"
        width="60rem"
        >
        <div class="box">
            <div class="item">
                <span>设备名称：</span>
                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
            </div>
            <div class="item">
                <span>设备型号：</span>
                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
            </div>
            <div class="item">
                <span>设备编码：</span>
                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
            </div>
            <div class="item">
                <span>数据接口：</span>
                <el-input v-model="form.name" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button style="margin-left: 3rem;" type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
        </el-dialog>
</template>

<script>
    export default {
        data(){
            return {
                dialogVisible:false,
                form:{
                    name:'',
                    model:'',
                    code:"",
                    interface:''
                }
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__header{
    font-weight: 700;
    padding: 3rem 5rem;
}
/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}
.item{
    display: flex;
    align-items: center;
    margin-top: 2rem;
}
.box> :nth-child(1){
    margin-top: 0;
}
.dialog-footer{
    display: flex;
    justify-content: center;
}
</style>